import { MappedLink } from "@insite/mobius/Menu";

export const AuthorizedPageTypeMappings: Map<string, string[]> = new Map([
    ["AnnualReturnsPage", ["Dana_Annual_Returns", "Dana_Annual_Returns_Admin"]],
]);

export const filterPageTypeByUserRoles = (menuItems: MappedLink[], userRoles: string[]): MappedLink[] => {
    const isAuthorized = (link: MappedLink) => {
        const requiredRoles = AuthorizedPageTypeMappings.get(link.type ?? "");
        return !requiredRoles || requiredRoles.some(role => userRoles.includes(role));
    };

     const prune = (items: MappedLink[]): MappedLink[] =>
        items
            .filter(isAuthorized)
            .map(item => {
                if (item.children && item.children.length > 0) {
                    const prunedChildren = prune(item.children);
                    return {
                        ...item,
                        children: prunedChildren.length ? prunedChildren : undefined,
                    };
                }
                return item;
            });

    return prune(menuItems);
};